import { render, staticRenderFns } from "./SimulacionFacturas.vue?vue&type=template&id=2f2f9698&"
import script from "./SimulacionFacturas.vue?vue&type=script&lang=ts&"
export * from "./SimulacionFacturas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports